// extracted by mini-css-extract-plugin
export default {"draggableList":"DraggableList_draggableList__hit2K"};